module.exports = __webpack_public_path__ + "img/es-ml.c555c992.svg";